<template>
  <div class="rule">
    <div class="title">活动规则</div>
    <div v-html="rule">
    </div>
  </div>
</template>
      
<script>
export default {
  name: "rule",
  data: function () {
    return {
      rule: "",
    };
  },
  methods: {
    // 获取活动规则接口
    getRules() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getRules,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.rule = res.data.data.msg;
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getRules();
  },
};
</script>
      
<style scoped>
</style>